import { useNavigate } from "react-router-dom";
import { MainHeaderActionsWrapper, MainWrapper } from "./style/home";
import { useEffect, useState } from "react";
import { getPushList, PushRes } from "../../api/push";
import { useRecoilValue } from "recoil";
import { pubState } from "../../recoil/pub.atom";
import { PageContentHeader, PageHeader, PageWrapper } from "../../styles/page";
import { PaginationWrapper } from "../../component/CommonTable";
import Pagination from "../../component/Pagination";
import { PubOwnerRole, PubOwnerDomain } from "../../api/cafe";

const PushList = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [list, setList] = useState<PushRes[]>([]);
  const size = 10;
  const pub = useRecoilValue(pubState);
  const [searchText, setSearchText] = useState("");
  const [isSearch, setIsSearch] = useState(false);

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.MARKETING)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  const getList = async () => {
    if (!pub) {
      return;
    }

    const res = await getPushList(pub.id);
    const filteredList = res.filter((item) =>
      item.title.toLowerCase().includes(searchText.toLowerCase()),
    );

    setTotalPage(Math.max(1, Math.ceil(filteredList.length / size)));
    setList(filteredList.slice((currentPage - 1) * size, currentPage * size));
  };

  const onPageChange = async (nextPage: number) => {
    setCurrentPage(nextPage);
  };

  const onSearchClick = () => {
    setCurrentPage(1); // 검색 시 첫 페이지로 초기화
    setIsSearch(true); // 검색이 실행되었음을 나타냄
    getList(); // 검색 실행
  };

  useEffect(() => {
    getList();
  }, [currentPage, isSearch]);

  const handleSend = () => {
    navigate("/pushSend");
  };

  const formatTime = (dateTime: string, time: boolean) => {
    if (!dateTime) return null;

    if (time) return dateTime.split(" ")[1];

    const date = dateTime.split(" ")[0];
    const [yyyy, mm, dd] = date.split("-");

    return `${yyyy}.${mm}.${dd}`;
  };

  return (
    <>
      <PageWrapper>
        <PageHeader>PUSH 메시지</PageHeader>
        <MainWrapper>
          <PageContentHeader>
            <div className="title">푸쉬 메시지 목록</div>
            <MainHeaderActionsWrapper>
              <div className="searchBox">
                <input
                  type="text"
                  placeholder="메시지 내용을 검색하세요"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <div className="searchIcon" onClick={() => onSearchClick()}>
                  <img src="/image-web/push/search.png" alt="검색 아이콘" />
                </div>
              </div>
              <div className="add-button" onClick={handleSend}>
                PUSH 메시지 보내기
              </div>
            </MainHeaderActionsWrapper>
          </PageContentHeader>
          <div className="table-wrapper">
            <div className="header">
              <div className="item z"></div>
              <div className="item a">내용</div>
              <div className="item b">발송일자</div>
              <div className="item c">시간</div>
              <div className="item d">상태</div>
              <div className="item e">대상</div>
              <div className="item f">발송 성공</div>
            </div>
            <div className="list-wrapper">
              {list.map((item, index) => (
                <div
                  className="data-wrapper"
                  key={index}
                  onClick={() => {
                    item.state === "TEMPORARY"
                      ? navigate(`/pushSend/${item.id}`)
                      : navigate(`/pushDetail/${item.id}`);
                  }}
                >
                  <div className="item z">
                    <img src="/image-web/push/message.png" alt="Selected" />
                  </div>
                  <div className="item a">
                    <span>{item.title}</span>
                  </div>
                  <div className="item b">
                    {formatTime(item.sendDate, false)}
                  </div>
                  <div className="item c">
                    {formatTime(item.sendDate, true)}
                  </div>
                  <div
                    className={`item d ${
                      item.state === "TEMPORARY" ? "res" : ""
                    }`}
                  >
                    {item.state === "SEND"
                      ? "완료"
                      : item.state === "RESERVATION"
                        ? "예약"
                        : "임시저장"}
                  </div>
                  <div className="item e">
                    {item.target === "ALL" ? "전체" : "핀포인트"}
                  </div>
                  <div className="item f">{item.pushCount}</div>
                </div>
              ))}
            </div>
          </div>
          {totalPage > 1 && (
            <PaginationWrapper>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPage}
                onPageChange={onPageChange}
              />
            </PaginationWrapper>
          )}
        </MainWrapper>
      </PageWrapper>
    </>
  );
};

export default PushList;
